import { Grid } from "@mui/material";
import React from "react";
import MerchantSummaryCard from "./MerchantSummaryCard";
import ViewMerchantTabs from "./ViewMerchantTabs";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";

const ViewMerchantDetailsNew = () => {
  const params = useParams();
  const { merchantId } = params;
  const merchantList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.merchantList
  );
  const userData = merchantList.find(
    (item: any) => item.leaseID === merchantId
  );
  const entireList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.entireListOfMerchants
  );
  const external_idForLogs = entireList.find(
    (item: any) => item.id === merchantId
  )?.external_id;

  return (
    <Grid display={"flex"} gap={4} height={"90vh"}>
      <Grid width={"25%"} height={"100%"}>
        <MerchantSummaryCard
          merchantId={external_idForLogs}
          merchant_name={userData?.merchant_name}
          promoImage={userData?.promoImage}
          status={userData?.status}
        />
      </Grid>
      <Grid width={"75%"}>
        <ViewMerchantTabs />
      </Grid>
    </Grid>
  );
};

export default ViewMerchantDetailsNew;
